import { useBetween } from "use-between";
import { useSelector } from "react-redux";
import { useEffect } from "react";

const useServices = () => {
  const {
    locale,
    selectedLaundryIndex,
    setServiceRequestCity,
    serviceRequestCity,
    serviceRequestBuilding,
    setServiceRequestBuilding,
    serviceRequestFloor,
    setServiceRequestFloor,
    serviceTypesSelect,
    setServiceTypesSelect,
    newItemType,
    setNewItemType,
    newServiceTypes,
    setNewServiceTypes,
    newNumberOfItems,
    setNewNumberOfItems,
    newPrice,
    setNewPrice,
    mainPrice,
    setMainPrice,
    totalPrice,
    setTotalPrice,
    priceAfterDiscount,
    setPriceAfterDiscount,
    flagPriceOffer,
    setFlagPriceOffer,
    newDetailedOrder,
    setNewDetailedOrder,
    TakeAndGiveCheckbox,
    setTakeAndGiveCheckbox,
  } = useBetween(useSelector((state) => state.useSharedState));
  const AllCities = useSelector((state) => state.AllCities);
  const Laundry = useSelector((state) => state.AllLaunds[selectedLaundryIndex]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        "latitude: 34.7175124";
        "longitude: 36.7181969";
        // console.log("latitude: " + position.coords.latitude);
        // console.log("longitude: " + position.coords.longitude);
      });
    } else {
      console.log("geolocation is not supported");
    }
  }, []);

  useEffect(() => {
    var disc = totalPrice;
    var discAmount = totalPrice * (Laundry.discountPercentage / 100);
    disc -= discAmount;
    setPriceAfterDiscount(disc);
  }, [flagPriceOffer]);

  const selectItemType = (e) => {
    if (e.target.value !== "") {
      setNewItemType(Laundry.services[e.target.value].itemType);
      setServiceTypesSelect(Laundry.services[e.target.value].servicesOnItem);
      // Reclear data if it is not empty
      setNewServiceTypes([]);
      setNewNumberOfItems(1);
      setNewPrice(0);
      setMainPrice(0);
    } else {
      setNewItemType("");
      setServiceTypesSelect([]);
    }
  };
  const selectServiceTypes = (e) => {
    // e.target.value is index of service
    // selectedService = [{ serviceOnItemId: 1, serviceName: 'غسيل', servicePrice: '50.0' }]
    if (e.target.value !== "") {
      let selectedService = serviceTypesSelect.filter((item) => {
        return item.serviceOnItemId === Number(e.target.value);
      });
      selectedService = selectedService[0];

      const tempservice = [...newServiceTypes, selectedService.serviceName];
      setNewServiceTypes(tempservice);
      setMainPrice(mainPrice + Number(selectedService.servicePrice));
      setNewPrice(
        (mainPrice + Number(selectedService.servicePrice)) * newNumberOfItems
      );

      const newTypes = serviceTypesSelect.filter((item) => {
        return item.serviceOnItemId !== Number(e.target.value);
      });
      setServiceTypesSelect(newTypes);
    } else {
      // Don't do anything
    }
  };

  const changeNumber = (e) => {
    setNewNumberOfItems(e.target.value);
    const x = e.target.value * mainPrice;
    setNewPrice(x);
  };

  const plusButton = () => {
    if (newItemType !== "" && newServiceTypes.length) {
      const temp = [
        ...newDetailedOrder,
        {
          id: newDetailedOrder.length + 1,
          itemType: newItemType,
          serviceTypes: newServiceTypes,
          numberOfItems: newNumberOfItems,
          price: newPrice,
        },
      ];
      setNewDetailedOrder(temp);
      setTotalPrice(totalPrice + newPrice);
      setFlagPriceOffer(!flagPriceOffer);

      // Return to scratch
      setNewItemType("");
      setNewServiceTypes([]);
      setNewNumberOfItems(1);
      setNewPrice(0);
      setMainPrice(0);
      const highlightedItems = document.querySelectorAll(".clean");

      highlightedItems.forEach((userItem) => {
        userItem.value = "";
      });
    }
  };

  const deleteRowServe = (id) => {
    const newOrder = newDetailedOrder.filter((item) => {
      if (item.id === id) {
        setTotalPrice(totalPrice - item.price);
        setFlagPriceOffer(!flagPriceOffer);
      }
      return item.id !== id;
    });
    setNewDetailedOrder(newOrder);
  };

  return {
    selectItemType,
    selectServiceTypes,
    changeNumber,
    plusButton,
    deleteRowServe,
    locale,
    selectedLaundryIndex,
    setServiceRequestCity,
    serviceRequestCity,
    serviceRequestBuilding,
    setServiceRequestBuilding,
    serviceRequestFloor,
    setServiceRequestFloor,
    serviceTypesSelect,
    setServiceTypesSelect,
    newItemType,
    setNewItemType,
    newServiceTypes,
    setNewServiceTypes,
    newNumberOfItems,
    setNewNumberOfItems,
    newPrice,
    setNewPrice,
    mainPrice,
    setMainPrice,
    totalPrice,
    setTotalPrice,
    priceAfterDiscount,
    setPriceAfterDiscount,
    flagPriceOffer,
    setFlagPriceOffer,
    newDetailedOrder,
    setNewDetailedOrder,
    TakeAndGiveCheckbox,
    setTakeAndGiveCheckbox,
    AllCities,
    Laundry,
  };
};

export default useServices;
